<script lang="ts">export let event;
</script>

<div class="grid gap-8 grid-cols-6">
    <a class="col-span-5 align-middle justify-start content-center flex" href={event.url}>
        {event.title} ({event.extendedProps.confirmedVolunteersCount}/{event.extendedProps.volunteers.length}&nbsp;<span class="icon-[tabler--user] self-center"></span>)
    </a>
    <div class="col-span-1 align-middle justify-center items-center hidden md:flex">
        <div class="tooltip">
            <div class="tooltip-toggle">
                <button class="flex align-middle justify-center items-center" aria-label="Popover Button"><span class="icon-[tabler--info-circle]"></span></button>
                <div class="tooltip-content tooltip-shown:opacity-100 tooltip-shown:visible" role="popover">
                    <div class="tooltip-body bg-primary max-w-xs rounded-lg p-4 text-start">
                        <ul class="list-inside list-disc">
                            {#each event.extendedProps.volunteers as volunteer}
                                <li class="mb-2">{volunteer}</li>
                            {/each}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
